﻿var jquery = require('jquery');
global.jQuery = global.$ = jquery;      // To get the jQuery object in the global scope because Bootstrap 4 doesn't do modules properly
var bootstrap = require('bootstrap');
var fancybox = require('@fancyapps/fancybox');
var topNavigation = require('./components/topNavigation');
var siteSearch = require('./components/siteSearch');
var cta = require('./components/cta');
var contactTranslateFooter = require('./components/connectTranslateFooter');
var lazyLoad = require('./components/lazyLoad');
var locationHighlight = require('./components/locationHighlight');
var popup = require('./components/popup');

$(function () {
    // topNavigation.initialize();
    siteSearch.initialize();
    cta.initialize();
    contactTranslateFooter.init();
    lazyLoad.initialize();
    locationHighlight.initialize();
    popup.initialize();
    //loginPopup.initialize();

    // Remove flash of unstyled content (fouc)
    $('.fouc').removeClass('fouc');
})
